export class Settings {
    static readonly languageCode: string = 'LANGUAGE';
}